import axios from "axios";
import baseURL from "./../api";
class ConfigurationService {
  getAgentCommissionList() {
    return axios.get(`${baseURL}/commission/group`);
  }
  getAgentLimitList() {
    return axios.get(`${baseURL}/limit`);
  }

  addAgentLimit(data) {
    return axios.post(`${baseURL}/limit`, data);
  }

  addAgentCommission(data) {
    return axios.post(`${baseURL}/commission/group`, data);
  }

  updateAgentLimit(id, data) {
    return axios.put(`${baseURL}/limit/${id}`, data);
  }

  deleteAgentLimit(id) {
    return axios.delete(`${baseURL}/limit/${id}`);
  }
  suspendAgentLimit(data) {
    return axios.post(`${baseURL}/limit/suspend/multiple`, data);
  }
  resumeAgentLimit(data) {
    return axios.post(`${baseURL}/limit/resume/multiple`, data);
  }

  deleteAgentCommission(id) {
    return axios.delete(`${baseURL}/commission/group/${id}`);
  }
  suspendAgentCommission(commissionGroupId) {
    return axios.post(`${baseURL}/commission/group/suspend/multiple`,commissionGroupId);
  }
  resumeAgentCommission(commissionGroupId) {
    return axios.post(`${baseURL}/commission/group/resume/multiple`, commissionGroupId);
  }

  getCommsionDetails(id) {
    return axios.get(`${baseURL}/commission/group/${id}`);
  }

  getAgentLimitDetails(id) {
    return axios.get(`${baseURL}/limit/${id}`);
  }

  getGatewayInfo() {

    return axios.get(`${baseURL}/gateway`);
  }
  createGateway(data) {
    return axios.post(`${baseURL}/gateway`,data);
  }

  updateWebHookStatus(data) {
    return axios.post(`${baseURL}/gateway/webhook/status-update`,data);
  }
  getCommissions(filterData, pageNumber, rowsPage) {
   console.log(filterData)
    filterData.userId = '';
    let formattedStartDate = '';
    let formattedEndDate = '';
    let paymentType = '';
    if(filterData.agent_id) {
      filterData.userId = filterData.agent_id
    }
    if(filterData.customer_id) {
      filterData.userId = filterData.customer_id
    }
    if(filterData.from_date) {
      const startDate = filterData.from_date; 
      const parts = startDate.split('-');
      formattedStartDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    if(filterData.end_date) {
      const startDate = filterData.end_date; 
      const parts = startDate.split('-');
      formattedEndDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    if(filterData.payment_method) {
      paymentType = filterData.payment_method.toUpperCase();
    }
    return axios.get(`${baseURL}/commission/history?fromDate=${formattedStartDate}&toDate=${formattedEndDate}&transactionType=${paymentType}&userId=${filterData.userId}&page=${pageNumber}&size=${rowsPage}`);
  }
  downloadCommssions(filterData, pageNumber, rowsPage) {
    console.log(filterData)
     filterData.userId = '';
     let formattedStartDate = '';
     let formattedEndDate = '';
     let paymentType = '';
     if(filterData.agent_id) {
       filterData.userId = filterData.agent_id
     }
     if(filterData.customer_id) {
       filterData.userId = filterData.customer_id
     }
     if(filterData.from_date) {
       const startDate = filterData.from_date; 
       const parts = startDate.split('-');
       formattedStartDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
     }
     if(filterData.end_date) {
       const startDate = filterData.end_date; 
       const parts = startDate.split('-');
       formattedEndDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
     }
     if(filterData.payment_method) {
       paymentType = filterData.payment_method.toUpperCase();
     }
     return axios.get(`${baseURL}/commission/download?fromDate=${formattedStartDate}&toDate=${formattedEndDate}&transactionType=${paymentType}&userId=${filterData.userId}&page=${pageNumber}&size=${rowsPage}`);
   }
 updateCommissionGroup(data, id) {
  return axios.put(`${baseURL}/commission/group/${id}`, data);

 }
}
export default new ConfigurationService();


